<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <img
      v-if="bannerList.length !== 0"
      :src="bannerList[0].CompanyName"
      class="img-fluid bg-img"
    />
    <!-- 面包屑 -->
    <div style="background-color: #f5f5f5;">
      <div class="crumbs_wrap type_area">
        <i class="iconfont iconweizhi1"></i>
        <span>您当前所在的位置：</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">首页</li>
          <li class="breadcrumb-item active" aria-current="page">入驻品牌</li>
        </ol>
      </div>
    </div>
    <!-- 内容 -->
    <div class="type_area content" v-html="brandDetail.CompanyLogo"></div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'

export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 顶部大图数据
      bannerList: [],
      brandDetail: {}
    }
  },

  created() {
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.getBannerList(2)
      this.getBrandDetails(2)
    } else {
      this.getBannerList(1)
      this.getBrandDetails(1)
    }
  },

  methods: {
    // 获取顶部大图
    async getBannerList(showTo) {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id}&ShowTo=${showTo}`
      )
      this.bannerList = res.data
    },

    async getBrandDetails(showTo) {
      const { data: res } = await this.$request.post(
        `/SX_RzhuPpai/GetRzhuDetial?Id=${this.$route.query.detailsId}&ShowTo=${showTo}`
      )
      this.brandDetail = res.data
    }
  }
}
</script>

<style lang="less" scoped>
// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.breadcrumb {
  padding: 0;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
}
.content {
  padding: 70px 0;
}
// 面包屑
.crumbs_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 30px !important;
  color: #666;

  .iconfont {
    color: #c41a26;
    font-size: 20px;
    padding-right: 10px;
  }
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }
  .content {
    padding: 35px 20px;
  }
  .iconfont {
    padding: 0 10px;
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
